import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const ConformalTransformation = () => (
  <QPhototModuleSubtopic
    title="Conformal transformation"
    videos={[
      "https://www.youtube.com/embed/ZvjKI4X5OOo",
      "https://www.youtube.com/embed/ks0clz_OXBU",
      "https://www.youtube.com/embed/CAVImDGWE8o",
      "https://www.youtube.com/embed/Ta_WjxpZpcw"
    ]}
    takeaways={[]}
    questions={[
        {text:'Find the image of the region bounded by the lines 1≤x≤2 under the transformation w=1/z. Also show the regions graphically '},
        {image:"/cvla_11.png"},
        {image:"/cvla_12.png"},
        {image:"/cvla_13.png"},
    

    ]}
    exampleVideos={[]}
  />
);

export default ConformalTransformation;
